import styled from "@emotion/styled";
import { BrowserRouter, Route, Switch } from "react-router-dom";
import "./App.css";
import Home from "./pages/Home";

import Gallery from "./pages/Gallery";
import GalleryImages from "./pages/Gallery/Section/Images";

import Services from "./pages/Services";
import Fabrication from "./pages/Services/Fabricated";
import Energy from "./pages/Services/Energy";
import Elevator from "./pages/Services/Elevator";
import Bore from "./pages/Services/Bore";

const Wrapper = styled.div`
  font-family: poppins;
`;
function App() {
  return (
    <Wrapper>
      <BrowserRouter>
        <Switch>
          <Route exact path="/" component={Home} />
          <Route exact path="/services" component={Services} />
          <Route exact path="/services/fabrication" component={Fabrication} />
          <Route exact path="/services/solar" component={Energy} />
          <Route exact path="/services/elevator" component={Elevator} />
          <Route exact path="/services/bore" component={Bore} />
          <Route exact path="/gallery" component={Gallery} />
          <Route exact path="/gallery/images" component={GalleryImages} />
        </Switch>
      </BrowserRouter>
    </Wrapper>
  );
}

export default App;
